import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthProvider'
import { Role } from '@/auth/roles'
import { RequireAuth } from '@/auth/RequireAuth'
import { AppLayout } from '@/components/AppLayout'
import { CallbackPage } from '@/pages/CallbackPage'
import { SilentRenewPage } from '@/pages/SilentRenewPage'
import { LoginPage } from '@/pages/LoginPage'
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { UsersPage } from '@/pages/UsersPage'
import { LeadsPage } from '@/pages/LeadsPage'
import { CustomersPage } from '@/pages/CustomersPage'
import { TradeFairsPage } from '@/pages/TradeFairsPage'
import { ProductCatalogPage } from '@/pages/ProductCatalogPage'
import { ForbiddenPage } from '@/pages/ForbiddenPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { Toaster } from '@/components/ui/sonner'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public — these are the routes the OIDC redirects land on. */}
          <Route path="/login" element={<LoginPage />} />
          {/* No token by definition — the caller has forgotten how to get one. */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/callback" element={<CallbackPage />} />
          <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
          <Route path="/forbidden" element={<ForbiddenPage />} />

          <Route
            element={
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route
              path="leads"
              element={
                <RequireAuth role={Role.SALES}>
                  <LeadsPage />
                </RequireAuth>
              }
            />
            <Route
              path="customers"
              element={
                <RequireAuth role={Role.SALES}>
                  <CustomersPage />
                </RequireAuth>
              }
            />
            <Route
              path="trade-fairs"
              element={
                <RequireAuth role={Role.SALES}>
                  <TradeFairsPage />
                </RequireAuth>
              }
            />
            <Route
              path="product-catalog"
              element={
                <RequireAuth role={Role.ADMIN}>
                  <ProductCatalogPage />
                </RequireAuth>
              }
            />
            <Route
              path="admin"
              element={
                <RequireAuth role={Role.ADMIN}>
                  <UsersPage />
                </RequireAuth>
              }
            />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        {/* Outside the routes: a toast raised by a dialog has to survive the dialog closing. */}
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  )
}
